/**
 * Shows a list of users which are registered for the application.
 * Material design: Table from https://material-ui.com/components/tables/#table
 */

import React from 'react'
import {Tooltip} from "@mui/material";
import {Google, MarkEmailRead, School, Unsubscribe} from "@mui/icons-material";


const UserAuthLogos = ({providers, emailVerified}) => {

    if (providers && !providers.length) {
        return <Tooltip title='Used Moodle sign-in'>
            <School/>
        </Tooltip>
    }
    return providers.map((provider) => {
        if (provider.providerId === 'google.com') {
            return <Tooltip key={provider} title='Used Google sign-in'>
                <Google/>
            </Tooltip>
        }
        if (provider.providerId === 'password' && emailVerified) {
            return <Tooltip key={provider} title='Used Password sign-in - email already verified'>
                <MarkEmailRead/>
            </Tooltip>
        }
        if (provider.providerId === 'password' && !emailVerified) {
            return <Tooltip key={provider} title='Used Password sign-in - email not yet verified'>
                <Unsubscribe/>
            </Tooltip>
        }
        return ''
    })
}
export default UserAuthLogos